import careerImage from 'assets/image/hmGoalCareer.webp';
import freelanceImage from 'assets/image/hmGoalFreelance.webp';
import startupImage from 'assets/image/hmGoalStartup.webp';
import careerGlow from 'assets/icons/hmGlowCareer.svg';
import freelanceGlow from 'assets/icons/hmGlowFreelance.svg';
import startupGlow from 'assets/icons/hmGlowStartup.svg';
import classes from './HomeGoals.module.scss';


// Три сценария, ради которых идут учиться. Тексты статичные: на бэкенде
// такого блока нет, он появился в редизайне.
const GOALS = [
  {
    id: 'career',
    title: 'Карьера в IT-компании',
    text:
      'Станьте частью новой культуры. Работайте над интересными проектами ' +
      'в команде с лучшими и получайте достойную оплату.',
    image: careerImage,
    glow: careerGlow,
  },
  {
    id: 'freelance',
    title: 'Работайте на фрилансе',
    text:
      'Работайте удалённо, принимая заказы из других стран. Высокий доход, ' +
      'свободный график и никакого начальника.',
    image: freelanceImage,
    glow: freelanceGlow,
  },
  {
    id: 'startup',
    title: 'Создайте IT-стартап',
    text:
      'Научитесь воплощать свои идеи в жизнь. Постройте новый Google ' +
      'или Facebook. Реализуйте свои мечты.',
    image: startupImage,
    glow: startupGlow,
  },
];

const GoalCard = ({ goal, wide, aosDelay }) => (
  // data-aos на обёртке: на самой карточке он подменял бы переходы ховера.
  <div
    className={`${classes.cardWrap} ${wide ? classes.cardWrapWide : ''}`}
    data-aos="fade-up"
    data-aos-delay={aosDelay}
  >
    <article className={`${classes.card} ${wide ? classes.cardWide : ''}`}>
      <div className={classes.text}>
        <h3 className={classes.title}>{goal.title}</h3>
        <p className={classes.desc}>{goal.text}</p>
      </div>

      <div className={classes.media}>
        <img className={classes.glow} src={goal.glow} alt="" aria-hidden />
        <img className={classes.image} src={goal.image} alt="" />
      </div>
    </article>
  </div>
);

const HomeGoals = () => (
  <section className={classes.goals}>
    <div className={classes.container}>
      <div className={classes.grid}>
        {GOALS.map((goal, i) => (
          <GoalCard key={goal.id} goal={goal} wide={i === 0} aosDelay={i * 120} />
        ))}
      </div>
    </div>
  </section>
);

export default HomeGoals;
